/* ==========================================================================
  Ajax
	-----------------------------------------------
	- open class for elements = .js-ajax-open
	- target ajax item(s) = '#ajaxTarget'
	- scroll on .ajax (overflow: hidden)
	- call loadIn on #ajaxContainer
	
	- 	$(‘#ajaxContainer’).rhLoadIn({
       		ajax:true
		})
    
    - 	$('.parallax').rhParallax({
			parallaxRatio:1.4,
			ajax:true,
			selector:'#ajaxContainer'
		});


  ========================================================================== */

var $ajaxOverlay = $("#ajaxOverlay"),
    $closeAjaxButton = $("#closeAjaxButton"),
    $ajaxDestination = $("#ajaxDestination"),
    ajaxOpen = false,
    originalHref,
    ajaxHref,
    $loader = $("#loader");

//ajax for cards
$(document).on("click", ".js-ajax-open", function (e) {
    e.preventDefault();

  

    ajaxHref = $(this).attr("href");


    if (ajaxOpen == false) {
        ajaxOpen = true;

        originalHref = window.location.href;

        $body.addClass("stop-scrolling");

        TweenMax.to($ajaxOverlay, 0.4, {
            autoAlpha: 1,
            top: "0",
            ease: Power4.easeInOut,
            onComplete: openAjax,
            onCompleteParams: [ajaxHref]
        });

        TweenMax.to($closeAjaxButton, 0.3, {
            autoAlpha: 1,
            ease: Power4.easeInOut,
            delay: 0.5
        });

    }

    history.pushState({}, "", ajaxHref);
});

//close ajax
$closeAjaxButton.on("click", function (e) {
    e.preventDefault();

    ajaxOpen = false;

    $body.removeClass("stop-scrolling");

    TweenMax.to($ajaxOverlay, 0.4, {
        autoAlpha: 0,
        top: "100%",
        ease: Power4.easeInOut,
        onComplete: emptyAjax
    });

    TweenMax.to($closeAjaxButton, 0.4, { autoAlpha: 0 });
    history.pushState({}, "", originalHref);
});

//history pop state
window.onpopstate = function () {
    $body.removeClass("stop-scrolling");

    if (ajaxOpen == true) {
        ajaxOpen = false;

        TweenMax.to($ajaxOverlay, 0.4, {
            autoAlpha: 0,
            top: "100%",
            ease: Power4.easeInOut,
            onComplete: emptyAjax
        });
    
        TweenMax.to($closeAjaxButton, 0.4, { autoAlpha: 0 });

        history.pushState({}, "", originalHref);
    }
};

function openAjax(ajaxHref) {
    $ajaxDestination.load(ajaxHref + " #ajaxSource", function () {
        $loader.fadeOut();

        $ajaxDestination.imagesLoaded(function () {
            //refire any functions here

            lazyLoad(threshold, "#ajaxOverlay");

        });
    });
}

function emptyAjax() {
    $ajaxDestination.empty();
}
